// let domain = "http://localhost:5000/trxn-apc/europe-west1/newApp";
let domain = "https://europe-west1-trxn-apc.cloudfunctions.net/newApp";
export const vdomain = "https://europe-west1-vhenga-site.cloudfunctions.net/appeu";

// if (window.location.origin.indexOf(":3000") > 0) domain = "http://localhost:5000/trxn-apc/europe-west1/newApp";

export {domain};